<template>
  <router-link class="eal" :class="{ 'eal--on': active }" :to="to" aria-label="프로필" data-tab="more">
    <img v-if="avatarUrl" class="eal__img" :src="avatarUrl" alt="" />
    <MemberAvatar v-else :name="name" :size="32" />
  </router-link>
</template>

<script>
// 프로필 moved out of the tab bar when 챌린지 took the first tab (2026-10): it
// is this avatar now, top right on every top-level page on a phone and beside
// the level pill in the desktop nav. It opens the same 프로필 page, so the
// account rows and the admin links are where they were.
import { waitForAuth } from '@/utils/authWait';
import userService from '@/api/userService';
import { fullName } from '@/utils/community';
import { enginePath } from '@/utils/engineNav';
import MemberAvatar from '@/components/profile/MemberAvatar.vue';

export default {
  name: 'EngineAvatarLink',
  components: { MemberAvatar },
  props: { active: { type: Boolean, default: false } },
  data() { return { avatarUrl: '', name: '', to: enginePath('/more') }; },
  async mounted() {
    try {
      const user = await waitForAuth();
      if (!user || !user.uid) return;
      const u = (await userService.getUser(user.uid)) || {};
      this.avatarUrl = u.avatarUrl || '';
      this.name = u.koreanName || fullName(u) || u.name || '';
    } catch (e) { /* the initials fallback stands */ }
  },
};
</script>

<style scoped>
.eal {
  flex: none; display: block; width: 32px; height: 32px; border-radius: 50%; position: relative;
  -webkit-tap-highlight-color: transparent; transition: transform 140ms var(--ease-press);
}
/* a 44px target around a 32px face */
.eal::after { content: ''; position: absolute; inset: -6px; border-radius: 50%; }
.eal__img { width: 32px; height: 32px; border-radius: 50%; object-fit: cover; display: block; }
.eal:active { transform: scale(0.94); }
.eal--on { box-shadow: 0 0 0 2px var(--surface), 0 0 0 4px var(--text-primary); }
.eal:focus-visible { outline: 2px solid var(--text-primary); outline-offset: 3px; }
@media (prefers-reduced-motion: reduce) { .eal { transition: none; } }
</style>
